import {DetailTable} from '../../../mapping-classes/detail-table';

export class Physical implements DetailTable {
  shieldedText = 'Afgeschermd';
  restrictedData: boolean;
  title: string;
  rowHeaders: string[];
  rowData: any[];
  errorText: string;

  constructor(physicalCards: any) {
    if (!physicalCards || physicalCards.continents === 0) {
      this.createErrorMessage();
    } else {
      this.restrictedData = physicalCards.restrictedData;
      this.rowHeaders = [];
      this.rowData = [];
      this.setRowHeaders();
      this.setRowData(physicalCards);
    }
  }

  createErrorMessage() {
    this.errorText = 'Er zijn geen deelnemende rekeningen.';
  }

  setRowHeaders() {
    this.rowHeaders = [
      'cardNumber',
      'sequenceNumber',
      'status',
      'designCode',
      'brand',
      'validUntil',
      'creationDate',
      'notificationPassFactoryDate',
      'expirationDate',
      'replacementDate',
      'replacementCardSequenceNumber',
      'blocksStartDate',
      'blocksRequestReason',
      'blocksRemovable',
      'requestReason',
      'pinUnchanged',
      'primaryAccountNumber',
      'numberOfActiveTokens',
    ];
  }

  setRowData(physicalCards) {
    physicalCards.forEach((physicalCard) => {
      if (this.restrictedData) {
        physicalCard.compensationLimit = this.shieldedText;
        physicalCard.actualBalance = this.shieldedText;
      }
      this.rowData.push(physicalCard);
    });
  }
}
